import { defineStore } from "pinia";
import { ref } from "vue";
import { CSVParser } from '../csvParser';

export const useGuestStore = defineStore("guest", () => {
  // TODO: change this to an object
  const defaultGuest = {
    name: "",
    attending: "No",
    email: "",
    accommodations: "",
    transportation: "",
    diet: "",
    characterName: "",
    bio: "",
    characterAppearance: "",
    imageUrl: "",
    completedSurvey: false,
  };
  const guest = ref(defaultGuest);
  const responses = ref([]);

  const loadGuest = () => {
    const storedGuest = localStorage.getItem("guest");
    if (storedGuest) {
      const parsedGuest = JSON.parse(storedGuest);
      guest.value = { ...parsedGuest };
    }
    // the csv might take a while to refresh... so this can cause old results to be loaded
    if (guest.value.email && responses.value.length > 0) {
      const submittedGuest = responses.value.find(
        (sub) => sub.email?.toLowerCase() === guest.value.email?.toLowerCase()
      );
      if (submittedGuest) {
        guest.value = {
          ...submittedGuest,
          completedSurvey: true,
        };

        // store the guest in local storage
        storeGuest();
      }
    }
  };

  const storeGuest = () => {
    localStorage.setItem("guest", JSON.stringify({
      ...guest.value,
      completedSurvey: guest.value.completedSurvey || false,
    }));
  };

  const saveResult = () => {
    guest.value.completedSurvey = true;
    // store the result in local storage
    storeGuest();
    const formData = new FormData();
    formData.append("entry.884278233", guest.value.name);
    formData.append("entry.1136586200", guest.value.attending);
    formData.append("entry.262420987", guest.value.email);
    formData.append("entry.598567540", guest.value.accommodations);
    formData.append("entry.520854053", guest.value.transportation);
    formData.append("entry.340530196", guest.value.diet);
    formData.append("entry.987721675", guest.value.characterName);
    formData.append("entry.454363011", guest.value.bio);
    formData.append("entry.1840407414", guest.value.characterAppearance);
    formData.append("entry.200732033", guest.value.imageUrl);

    // push or replace this guest in the responses array
    const existingGuest = responses.value.find(
      (g) => g.email?.toLowerCase() === guest.value.email?.toLowerCase()
    );
    if (existingGuest) {
      const index = responses.value.findIndex(
        (g) => g.email?.toLowerCase() === guest.value.email?.toLowerCase()
      );
      responses.value[index] = { ...guest.value };
    } else {
      responses.value.push({
        ...guest.value,
      });
    }

    return fetch(
      "https://docs.google.com/forms/u/0/d/e/1FAIpQLSdcPMKofTNQsopjBtP_In6OVtL8Y5xtBlINkhf6opy9VjA2xg/formResponse",
      {
        method: "POST",
        mode: "no-cors",
        body: formData,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const loadResponses = async () => {
    // Add timestamp to prevent caching
    const timestamp = new Date().getTime();
    const csvUrl = `https://docs.google.com/spreadsheets/d/e/2PACX-1vTkYeyHOfPS6cKtIHjizEuJogvjzMWeHFHz9PhX42imBzN6FxE5F7Vk3zBcOn4Ki3i2q0JR2S-wGt8j/pub?gid=237881577&single=true&output=csv&_=${timestamp}`;

    try {
      responses.value = await CSVParser.parseGoogleSheet(csvUrl);
      console.log(responses.value);
    } catch (error) {
      console.error("Error fetching Google Sheets CSV:", error);
    }
  };

  const formattedPrompt = (name, description, random = false) => {
    return `
    Name: ${name}, description: ${description}.
    `.replace(/\s+/g, ' ').trim();
  }

  const generateCharacterImage = async (name, description) => {
    const prompt = formattedPrompt(name, description);

    const response = await fetch(process.env.LAMBDA_URL, {
      method: "POST",
      body: JSON.stringify({
        stableDiffusion: "core",
        generateDetailedPrompt: false,
        email: guest.value.email,
        output_format: "png",
        prompt: prompt,
        negative_prompt: "worst quality, low quality, text, error, cropped, jpeg artifacts, signature, watermark, username, blurry, bad anatomy, bad hands, text, error, cropped, jpeg artifacts, signature, watermark, username, blurry, bad anatomy, bad hands",
        seed: 0,
        style_preset: 'pixel-art',
        steps: 30,
        samples: 3,
        cfg_scale: 8,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    return data;
  };

  return {
    guest,
    responses,
    saveResult,
    loadGuest,
    loadResponses,
    generateCharacterImage,
  };
});
